import { useEffect } from 'react';
import Head from 'next/head';

export default function Custom404() {
  useEffect(() => {
    if (process.env.NODE_ENV !== 'development') {
      window.location.href = 'https://oops.cloud.sbs.co.kr/noname.html';
    }
  }, []);

  return (
    <h1>
      <Head>
        <link
          key="css_pc_url"
          rel="stylesheet"
          href={`${process.env.NEXT_PUBLIC_GLOBAL_CSS_PC_URL}?v=${process.env.NEXT_PUBLIC_BUILD_TIME}`}
        />
        <meta
          key="viewport"
          name="viewport"
          content="width=device-width, initial-scale=1"
        />
        <script
          key="gnb_js_url"
          type="text/javascript"
          src={process.env.NEXT_PUBLIC_GNB_JS_URL}
        />
      </Head>
      404 - 페이지를 찾을 수 없습니다.
    </h1>
  );
}
